import React, { Fragment, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { BsCheckCircle } from "react-icons/bs";
import { BsQuestionCircle } from "react-icons/bs";
import { ReactComponent as CrossIcon } from "../../../../../assets/utils/images/svgs/Cross.svg";
import { ReactComponent as Save } from "../../../../../assets/utils/images/svgs/save_two.svg";
import { ReactComponent as Multiplication } from "../../../../../assets/utils/images/svgs/Frame_two.svg";
import { Button, Card, CardBody, CardFooter, Col, DropdownMenu, DropdownToggle, Nav, NavLink, Row, UncontrolledButtonDropdown, Input, Modal, ModalHeader, ModalBody, } from "reactstrap";
import VervangerDetails from "Pages/Vervanger/Home/Show/Partials/VervangerDetails";
import VervangerTable from "Pages/Vervanger/Home/Show/Partials/VervangerTable";
import PageHeading from "Layout/AppMain/PageHeading";
import { toast } from "react-toastify";
import { useAllRequest, useCurrentRequest, useFullPeriod, useOpenRequest, useUpdateSubstitutionStatus } from "Api/Vervanger/Home";
import { useNavBlock } from "helperFunctions/GuardNavigation";



const Default = (props) => {

    const params = useParams();
    const [substitutionDetails, setSubstitutionDetails] = useState(null);
    const [substitutionDays, setSubstitutionDays] = useState([]);
    const [jsonData, setJsonData] = useState([]);
    const [changeCount, setChangeCount] = useState(0);
    const [showFilter, setShowFilter] = useState(false);
    const [showStatus, setShowStatus] = useState(false);
    const [isFilter, setIsFilter] = useState(0);
    const [showUnsavedModal, setShowUnsavedModal] = useState(false);

    const {
        setOpenUnsavedModal,
        proceedNavigation,
        pendingNavigation,
        setHasUnsavedChanges,
        cancelNavigation,
        guardedNavigate
    } = useNavBlock();

    useEffect(() => {
        setOpenUnsavedModal(() => () => setShowUnsavedModal(true));

        return () => {
            setOpenUnsavedModal(null);
        };
    }, []);

    let navigate = useNavigate();
    const subId = params.id || '';

    useEffect(() => {
        setHasUnsavedChanges(jsonData.length > 0);
    }, [jsonData]);


    const {
        trigger: updateStatusMutation,
    } = useUpdateSubstitutionStatus(subId);

    let days = jsonData;
    const changeStatus = (dayId, status, statusOfAll) => {

        // Deep copy so React gets a new object
        const newDays = JSON.parse(JSON.stringify(substitutionDays));

        // Copy jsonData instead of mutating it
        let updatedDays = [...jsonData];

        if (statusOfAll === "acceptAll") {

            updatedDays = [];

            Object.keys(newDays).forEach((key) => {
                Object.keys(newDays[key]).forEach((day) => {

                    const ochtend = newDays[key][day].Ochtend;
                    const middag = newDays[key][day].Middag;

                    if (
                        ochtend &&
                        ochtend.status === "Aangevraagd" &&
                        ochtend.substitutionId == subId
                    ) {

                        ochtend.status = status;

                        updatedDays.push({
                            id: ochtend.id,
                            eSubStatus: status,
                        });
                    }

                    if (
                        middag &&
                        middag.status === "Aangevraagd" &&
                        middag.substitutionId == subId
                    ) {

                        middag.status = status;

                        updatedDays.push({
                            id: middag.id,
                            eSubStatus: status,
                        });
                    }
                });
            });

            setShowStatus(false);
        } else {

            updatedDays = updatedDays.filter((d) => d.id !== dayId);

            updatedDays.push({
                id: dayId,
                eSubStatus: status,
            });
            setChangeCount(prev => prev + 1);
            Object.keys(newDays).forEach((key) => {
                Object.keys(newDays[key]).forEach((day) => {

                    if (
                        newDays[key][day].Ochtend &&
                        newDays[key][day].Ochtend.id == dayId
                    ) {
                        newDays[key][day].Ochtend.status = status;
                    }

                    if (
                        newDays[key][day].Middag &&
                        newDays[key][day].Middag.id == dayId
                    ) {
                        newDays[key][day].Middag.status = status;
                    }
                });
            });
        }

        setSubstitutionDays(newDays);
        setJsonData(updatedDays);
    };

    const removeDay = (day) => {
        jsonData.map((value, index) => {
            if (value.id === day.id) {
                jsonData.splice(index, 1);
            }
        })
    }

    const {
        data: currentRequestResponse,
        isLoading,
    } = useCurrentRequest(
        isFilter === 0 ? subId : null
    );

    useEffect(() => {
    if (
        currentRequestResponse?.status === false &&
        currentRequestResponse?.error === "invalid_link"
    ) {
        navigate("/no-page-found");
    }
}, [currentRequestResponse, navigate]);


    const {
        data: openRequestResponse,
    } = useOpenRequest(
        isFilter === 1 ? subId : null
    );

    const filterRequest = (filter) => {
        if (filter == 1 && isFilter == 1) {
            setIsFilter(0);
        } else if (filter == 2 && isFilter == 2) {
            setIsFilter(4);
        } else if (filter == 3 && isFilter == 3) {
            setIsFilter(0);
        } else {
            setIsFilter(filter);
        }
    }

    const {
        data: allRequestResponse,
    } = useAllRequest(
        isFilter === 2 ? subId : null
    );

    const updateStatus = async () => {

        try {
            const response =
                await updateStatusMutation({
                    data: jsonData,
                });
            if (response?.data?.status === 'success') {
                toast.success(
                    "Status succesvol bijgewerkt"
                );
                setJsonData([]);
                setChangeCount(0);
                setHasUnsavedChanges(false);

                setTimeout(() => {
                    if (pendingNavigation) {
                        proceedNavigation();
                    } else {
                        setShowUnsavedModal(false);
                    }
                }, 300);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const toggleFilter = () => {
        setShowFilter(prev => !prev);
    };

    const toggleStatus = () => {
        setShowStatus(prev => !prev);
    };


    const {
        data: fullPeriodResponse,
    } = useFullPeriod(
        isFilter === 3 ? subId : null
    );

    useEffect(() => {
        let response = null;

        switch (isFilter) {
            case 1:
                response = openRequestResponse;
                break;
            case 2:
                response = allRequestResponse;
                break;
            case 3:
                response = fullPeriodResponse;
                break;
            default:
                response = currentRequestResponse;
        }
        if (
            response?.data?.id !== undefined
        ) {
            setSubstitutionDetails(response);
            if (response.data.substitutionDays) {
                setSubstitutionDays(
                    response.data.substitutionDays
                );
            }

        } else if (response) {
            setSubstitutionDays([]);
        }
    }, [
        isFilter,
        currentRequestResponse?.data,
        openRequestResponse,
        allRequestResponse,
        fullPeriodResponse,
    ]);

    if (!substitutionDetails) return <Card><CardBody><div class="text-center">Geen data beschikbaar</div></CardBody></Card>;
    return (

        <Fragment>
            <TransitionOnLoad>
                <div>
                    <div className="chat-layout-wrapper">
                        <div className="app-inner-layout chat-layout" >
                            <PageHeading />
                            <div className="app-inner-layout__wrapper">
                                <Card className="app-inner-layout__content">
                                    <Row>
                                        <Col md="12">

                                            <VervangerDetails substitutionDetails={substitutionDetails} />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md="12">
                                            <VervangerTable substitutionDays={substitutionDays} id={substitutionDetails?.data.id} changeStatus={changeStatus} />
                                        </Col>
                                    </Row>
                                </Card>
                            </div>
                            <div className="chat-layout-footer">
                                <CardFooter className="d-block text-center d-flex chat-layout-footer__inner align-items-center">
                                    <div className="flex-grow-1 d-flex justify-content-start gap-2 align-items-center">
                                        <div>

                                            <UncontrolledButtonDropdown isOpen={showFilter}>
                                                <DropdownToggle color="link" className="p-0">

                                                    <Button className="custom-btn-width btn-color-style  me-1" size="sm" outline color="primary" onClick={toggleFilter} >
                                                        Filter
                                                    </Button>
                                                </DropdownToggle>
                                                <DropdownMenu className="rm-pointers dropdown-menu-lg dropdown-width">
                                                    <Nav vertical>

                                                        <NavLink
                                                            className={`link-gap ${isFilter === 0 ? "active-filter" : ""}`}
                                                            onClick={() => {
                                                                filterRequest(0);
                                                                setShowFilter(false);
                                                            }}
                                                        >
                                                            <span><BsCheckCircle color="#39A825" fontSize="21px" /></span>
                                                            <span>Huidig verzoek</span>
                                                        </NavLink>

                                                        <NavLink
                                                            className={`link-gap navlink-border ${isFilter === 1 ? "active-filter" : ""}`}
                                                            onClick={() => {
                                                                filterRequest(1);
                                                                setShowFilter(false);
                                                            }}
                                                        >
                                                            <span><BsQuestionCircle color="#F2983E" fontSize="21px" /></span>
                                                            <span>Openstaand in huidig verzoek</span>
                                                        </NavLink>

                                                        <NavLink
                                                            className={`link-gap ${isFilter === 2 ? "active-filter" : ""}`}
                                                            onClick={() => {
                                                                filterRequest(2);
                                                                setShowFilter(false);
                                                            }}
                                                        >
                                                            <span><CrossIcon color="#FB2E5F" /></span>
                                                            <span style={{ marginLeft: "-5px" }}>Alle dagdelen</span>
                                                        </NavLink>


                                                    </Nav>
                                                </DropdownMenu>
                                            </UncontrolledButtonDropdown>
                                        </div>
                                        <div>


                                            <UncontrolledButtonDropdown isOpen={showStatus}>
                                                <DropdownToggle color="link" className="p-0">

                                                    <Button className="custom-btn-width btn-color-style  me-1" size="sm" outline color="primary" onClick={toggleStatus} >
                                                        Wijzig alle dagdelen
                                                    </Button>
                                                </DropdownToggle>
                                                <DropdownMenu className={"rm-pointers dropdown-menu-lg  dropdown-width"} >

                                                    <Nav vertical>
                                                        <NavLink className="link-gap" onClick={() => {
                                                            changeStatus(
                                                                substitutionDays, 'Ingepland', 'acceptAll');
                                                            setShowStatus(false);
                                                        }}>
                                                            <span><BsCheckCircle color='#39A825' fontSize={"21px"} />  </span>
                                                            <span>Accepteer alle dagdelen</span>
                                                        </NavLink>

                                                        <NavLink className="link-gap navlink-border" >
                                                            <span><BsQuestionCircle color='#F2983E' fontSize={"21px"} />  </span>
                                                            <span>Nog geen keuze gemaakt</span>
                                                        </NavLink>

                                                        <NavLink className="link-gap" onClick={() => {
                                                            changeStatus(
                                                                substitutionDays, 'Geannuleerd', 'acceptAll');
                                                            setShowStatus(false);
                                                        }}>
                                                            <span><CrossIcon color='#FB2E5F' /> </span>
                                                            <span style={{ marginLeft: '-5px' }}>Weiger alle dagdelen</span>
                                                        </NavLink>
                                                    </Nav>
                                                </DropdownMenu>
                                            </UncontrolledButtonDropdown>
                                        </div>
                                    </div>

                                    <div className={"svg-color-style"}>
                                        <Button size="sm" outline className="opslaan-btn-style me-1 btn-color-style" color="primary" onClick={() => guardedNavigate('/home')}>
                                            Annuleren
                                        </Button>
                                        <Button size="sm" outline className="opslaan-btn-style me-1 btn-color-style" color="primary" onClick={updateStatus} >
                                            <span className="ms-1">Toepassen</span>
                                            {jsonData.length > 0 && (
                                                <span className="blue-circle">
                                                    {jsonData.length}
                                                </span>
                                            )}
                                            {/* Opslaan{jsonData.length > 0 && `(${jsonData.length})`} */}
                                        </Button>


                                    </div>
                                </CardFooter>
                            </div>
                        </div>
                    </div>
                </div>

                {jsonData.length > 0 &&
                    <Modal id={"tooltip"} isOpen={showUnsavedModal} className="modal-dialog__over feedback-modal-style opmerking-modal-styling info-modal-width">
                        <ModalHeader >
                            <div className="modal-header-styling" >
                                Niet-opgeslagen wijzigingen
                            </div>
                            <div className="cross-icon-color">
                                <i className="nav-link-icon lnr-cross m-1 cursor-pointer" onClick={() => setShowUnsavedModal(false)}> </i>
                            </div>
                        </ModalHeader>

                        <ModalBody className="bg-white rounded">

                            <p className="contracttype-Modal" >
                                Er zijn wijzigingen die nog niet zijn opgeslagen. Wil je deze opslaan voordat je verdergaat?
                            </p>



                            <div className="d-flex justify-content-center gap-3">
                                <Button
                                    className="d-flex align-items-center btn-color-style opslaan-btn btn btn-outline-primary btn-sm info-btn-padding mt-4"
                                    size="sm"
                                    outline
                                    color="primary"
                                    type="submit"
                                    onClick={() => {
                                        setHasUnsavedChanges(false);
                                        proceedNavigation();
                                    }}
                                >
                                    Annuleren
                                </Button>
                                <Button
                                    className="d-flex align-items-center btn-color-style opslaan-btn btn btn-outline-primary btn-sm info-btn-padding mt-4"
                                    size="sm"
                                    outline
                                    color="primary"
                                    onClick={() => {
                                        setHasUnsavedChanges(false);
                                        proceedNavigation();
                                    }}
                                >
                                    Niet opslaan
                                </Button>

                                <Button
                                    className="d-flex align-items-center btn-color-style opslaan-btn btn btn-outline-primary btn-sm info-btn-padding mt-4"
                                    size="sm"
                                    outline
                                    color="primary"
                                    onClick={updateStatus}
                                >
                                    <span className="ms-1">Toepassen</span>
                                    <span>
                                        {jsonData.length > 0 && `(${jsonData.length})`}
                                    </span>
                                </Button>
                            </div>

                        </ModalBody>
                    </Modal >
                }
            </TransitionOnLoad>

        </Fragment>
    )
}


export default Default;
